import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import '@cds/core/input/register.js';
import { getData } from './utils';
const selectableData = getData().map(i => {
    i.selected = false;
    return i;
});
let DemoEditable = class DemoEditable extends LitElement {
    constructor() {
        super(...arguments);
        this.data = selectableData;
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column>Account</cds-grid-column>
        <cds-grid-column>Outstanding</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>
              
              ${entry.selected
            ? html `
                  <cds-input>
                    <label cds-layout="display:screen-reader-only">${entry.id} Outstanding Value</label>
                    <input class="${entry.id}-input" type="number" .value=${entry.average} @keydown=${e => this.updateEntry(e, entry)} />
                    <cds-control-action action="prefix" readonly>$&nbsp;</cds-control-action>
                  </cds-input>`
            : html `
                  <cds-inline-button class="${entry.id}-button" @click=${() => this.editEntry(entry)} aria-label="edit ${entry.id}"><cds-icon shape="pencil" solid></cds-icon></cds-inline-button>
                  <span>$${entry.average}</span>
                `}
            </cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
    `;
    }
    updateEntry(e, entry) {
        if (e.code === 'Enter' || e.code === 'Escape') {
            entry.average = e.target.value;
            entry.selected = false;
            this.data = [...this.data];
            setTimeout(() => this.querySelector(`.${entry.id}-button`).focus());
        }
    }
    editEntry(entry) {
        entry.selected = true;
        this.data = [...this.data];
        setTimeout(() => this.querySelector(`.${entry.id}-input`).focus());
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoEditable.prototype, "data", void 0);
DemoEditable = __decorate([
    customElement('demo-editable')
], DemoEditable);
export { DemoEditable };
//# sourceMappingURL=demo.cell-editable.js.map